import { render, staticRenderFns } from "./SavingsWaitlist.vue?vue&type=template&id=40b992ec"
import script from "./SavingsWaitlist.vue?vue&type=script&lang=js"
export * from "./SavingsWaitlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports